import React, { useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import ContentContainer from './../items/ContentContainer';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import MuvikaService from '../../services/muvika';
import Stack from '@mui/material/Stack';
import Waiting from './../items/Waiting';
import TR from './../../Trans';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import sessionStore from './../../stores/session';
import messageStore from './../../stores/message';

function Feedback() {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);

  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [songTitle, setSongTitle] = useState(null);
  const [artist, setArtist] = useState(null);

  const sendFeedback = () => {
    if (type === "bug_report" || type === "feature_request" || type === "other" || type === "song_suggestion") {
      if (description.trim().length > 0 || type === "song_suggestion") {
        setIsWaiting(true);
        MuvikaService.sendFeedback(sessionToken, type, description.trim(), songTitle, artist)
          .then(function (res) {
            if (res.data.error) {
              if (type !== "song_suggestion") {
                setDescription("");
                setType("");
                setArtist(null);
                setSongTitle(null);

              }
              setIsWaiting(false);
              setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              setDescription("");
              setType("");
              setArtist(null);
              setSongTitle(null);
              setIsWaiting(false);
              setMessage(sessionToken, TR.cm_feedback_saved_thanks);
            }
          })
          .catch(function () { });
      } else {
        setError(sessionToken, 0, TR.cm_set_description);
      }
    } else {
      setError(sessionToken, 0, TR.cm_set_feedback_type);
    }
  };

  const handleChangeType = (event) => {
    setType(event.target.value);
  };

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleChangeSongTitle = (event) => {
    setSongTitle(event.target.value);
  };

  const handleChangeArtist = (event) => {
    setArtist(event.target.value);
  };

  const renderSendButton = () => {
    if (!isWaiting) {
      return <Button className="muvika-button-right" onClick={sendFeedback} variant="text" color="success">{TR.cm_send}</Button>;
    }
  };

  const renderSongSuggestion = () => {
    if (type === "song_suggestion") {
      return <FormGroup>
        <InputLabel>{TR.cm_song_title}</InputLabel>
        <TextField size="small" onChange={handleChangeSongTitle} value={songTitle}/>
        <InputLabel>{TR.cm_artist}</InputLabel>
        <TextField size="small" onChange={handleChangeArtist} value={artist}/>
      </FormGroup>;
    }
  };

  const renderDescription = () => {
    if (type === "song_suggestion") {
      return <>
        <InputLabel>{TR.cm_suggestion_additional_info}</InputLabel>
        <TextField
          placeholder={TR.cm_suggestion_additional_info_placeholder}
          value={description}
          onChange={handleChangeDescription}
          multiline
          rows={10}
          inputProps={{ maxLength: 5000 }}
        />
      </>;
    } else {
      return <>
        <InputLabel>{TR.cm_description}</InputLabel>
        <TextField
          onChange={handleChangeDescription}
          multiline
          rows={10}
          inputProps={{ maxLength: 5000 }}
        />
      </>;
    }
  };

  const waitingRender = () => {
    if (isWaiting) {
      return <Waiting />;
    } else {
      return <ContentContainer id="muvika-feedback" onScrollDown={() => {
      }} isFinished={true}>
        <FormGroup>
          <Stack spacing={0}>
            <InputLabel>{TR.cm_feedback_type}</InputLabel>
            <Select className="muvika-select" onChange={handleChangeType} value={type}>
              <MenuItem value={"bug_report"}>{TR.cm_bug_report}</MenuItem>
              <MenuItem value={"song_suggestion"}>{TR.cm_song_suggestion}</MenuItem>
              <MenuItem value={"feature_request"}>{TR.cm_feature_request_or_improvement}</MenuItem>
              <MenuItem value={"other"}>{TR.cm_other}</MenuItem>
            </Select>
            {renderSongSuggestion()}
            {renderDescription()}
          </Stack>
        </FormGroup>
      </ContentContainer>;
    }
  };

  return (
    <div>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <h3>{TR.cm_feedback}</h3>
        </Grid>
        <Grid item xs={2}>
          {renderSendButton()}
        </Grid>
      </Grid>
      {waitingRender()}
    </div>
  );
}

export default Feedback;